var menu = 'closed';
jQuery('.mobile-menu-trigger').click(function(){
    (menu == 'closed') ? openMenu() : closeMenu();
});

function openMenu(){
    jQuery('header').addClass('headroom--menu-open');
    jQuery('.mobile-menu-bg').removeClass('mobile-menu-bg--hidden');
    jQuery('.mobile-menu-trigger').removeClass('mobile-menu-trigger--initial').addClass('mobile-menu-trigger--close');
    jQuery('.mobile-menu-container').addClass('mobile-menu-container--show');
    jQuery('.mobile-menu-viewport').addClass('mobile-menu-viewport--active');
    menu = 'open';
    disableScroll();
}

function closeMenu(){
    jQuery('.mobile-menu-bg').addClass('mobile-menu-bg--hidden');
    jQuery('.mobile-menu-container').removeClass('mobile-menu-container--show');
    jQuery('.mobile-menu-trigger').removeClass('mobile-menu-trigger--close').addClass('mobile-menu-trigger--initial');
    jQuery('header').removeClass('headroom--menu-open');
    jQuery('.mobile-menu-viewport').removeClass('mobile-menu-viewport--active');
    menu = 'closed';
    enableScroll();
}

function header(pjax){
    var headroom  = new Headroom(document.querySelector("header"), {
        offset : '6',
        tolerance : {
            up : 12,
            down : 12
        }
    });
    headroom.init();

    jQuery('.submenu-one').click(function(){
        togglePopout(jQuery(this), 'one', pjax);
    });

    jQuery('.submenu-two').click(function(){
        togglePopout(jQuery(this), 'two', pjax);
    });

}

function togglePopout($this, contentId, pjax){
    if(jQuery($this).hasClass('active')){
        jQuery($this).removeClass('active');
        jQuery('.fancy-popout').removeClass('active').removeClass('finished');
        jQuery('.popout-content').removeClass('active');
        jQuery('header.headroom').removeClass('headroom--menu-open');
    }else{
        var popoutWidth = (jQuery(window).width() - jQuery('.nav-right').offset().left) + 72;
        jQuery('.fancy-popout').css({'width': popoutWidth});
        jQuery('.submenu').removeClass('active');
        jQuery($this).addClass('active');
        if(jQuery('.fancy-popout').hasClass('active')){
            jQuery('.popout-content').removeClass('active');
            jQuery('.popout-content[data-id="'+contentId+'"]').addClass('active');
        }else{
            jQuery('.popout-content').removeClass('active');
            jQuery('.popout-content[data-id="'+contentId+'"]').addClass('active');
            jQuery('.fancy-popout').addClass('active');
            setTimeout(function(){
                jQuery('.fancy-popout').addClass('finished');
            }, 600)
        }
        jQuery('header.headroom').addClass('headroom--menu-open');
        jQuery('main').click(function(){
            jQuery('.fancy-popout').removeClass('active').removeClass('finished');
            jQuery('.popout-content').removeClass('active');
            jQuery('.submenu').removeClass('active');
            jQuery('main').unbind('click');
        })
    }
}


function disableScroll() {
    var scrolled = jQuery(window).scrollTop();
    jQuery('body').data('scrolled', scrolled);
    jQuery('body').css({'position': 'fixed',
    'top': '-' + scrolled + 'px',
    'left': '0px',
    'width': '100%',
    'overflow-y': 'scroll'});
}

function enableScroll() {
    jQuery('body').css({'position': 'relative',
    'top': 'auto',
    'left': 'auto',
    'overflow': 'auto'});
    window.scrollTo(0, jQuery('body').data('scrolled'));
}
